<script>
    import 'bootstrap/dist/css/bootstrap.min.css';
    import Cookies from 'js-cookie';
    import Container from 'sveltestrap/src/Container.svelte';
    import Row from 'sveltestrap/src/Row.svelte';
    import Col from 'sveltestrap/src/Col.svelte';
    import Collapse from 'sveltestrap/src/Collapse.svelte';
    import ButtonDropdown from 'sveltestrap/src/ButtonDropdown.svelte';
    import DropdownMenu from 'sveltestrap/src/DropdownMenu.svelte';
    import DropdownToggle from 'sveltestrap/src/DropdownToggle.svelte';

    import {goto} from '$app/navigation';
    import {page} from '$app/stores';

    import {query, previous_query, categories, start_date, start_date_string, end_date, end_date_string, current_dossier_id, do_load} from '$lib/store.js';

    import Badge from '$lib/Badge.svelte';
    import {landingpage_url, app_url} from '$lib/svelte_1848_settings.js';
    import {post_call, clear_state} from '$lib/utils.js';

    import logo from './logo-app-wit.svg';
    import user_icon from './user-icon.svg';

    let is_open = false;

    function handle_update(event) {
        is_open = event.detail.isO
    }

    async function logout() {
        Cookies.remove('authenticatedAccount');
        await post_call({endpoint: '/auth/logout/'});
        clear_state();
        // Reload +page.server.js (to get correct cookies) and +page.js
        goto(`${app_url}app`, {invalidateAll: true});
    }
</script>

<header>
    <nav aria-labelledby="hoofdmenu" class="navbar navbar-expand-xl">
        <div class="container-fluid">
            <p id="hoofdmenu" class="visually-hidden">Hoofdmenu</p>
            <Container fluid class="gx-0">
                <Row class="gy-0">
                    <Col class="gx-0">
                        <div class="navbar-app">
                            <div class="d-inline-block">
                                <a class="navbar-brand" href="{app_url}app" data-sveltekit-preload-data="off" on:click|preventDefault={() => {clear_state(); $do_load = true; goto(`${app_url}app`, {invalidateAll: true});}}>
                                    <img id="nav-logo" src={logo} alt="1848 monitor logo" width="180.333" height="51">
                                </a>
                                <span class="visually-hidden text-white">1848 monitor</span>

                                <div id="badge-div" class="d-inline-block">
                                    {#if $page.data.logged_in}
                                        <Badge bg_color={'gold'} text={'PRO'}/>
                                    {:else}
                                        <Badge bg_color={'light-blue4'} text={'BASIS'}/>
                                    {/if}
                                </div>
                            </div>

                            <div class="d-inline d-sm-none">
                                {#if $page.data.logged_in}
                                    <ButtonDropdown class="float-end" style="margin-top: 9px;">
                                        <DropdownToggle color="link" class="pb-0">
                                            <img class="user-icon" src={user_icon} alt="Icoontje van een gebruiker" width="21.81" height="24.2">
                                        </DropdownToggle>
                                        <DropdownMenu>
                                            <a class="wijzig-wachtwoord" href="/herstel-wachtwoord"><span>Wijzig wachtwoord</span></a>
                                            <button type="button" class="dropdown-item logout no-hover-bg" on:click={logout}>Log uit</button>
                                        </DropdownMenu>
                                    </ButtonDropdown>
                                {:else}
                                    <button id="navbar-toggler" class="float-end btn" title="menu" on:click={() => (is_open = !is_open)}>
                                        <span class="navbar-toggler-icon"></span>
                                    </button>

                                    <Collapse isOpen={is_open} navbar expand="sm" on:update={handle_update}>
                                        <Row class="gx-0">
                                            <Col xs={{offset: 3, size: 6}}>
                                                <ul class="navbar-nav pt-3 pb-2">
                                                    <li class="nav-item">
                                                        <a class="nav-link justify-content-center text-white pb-3" href="{app_url}registreer">Registreren</a>
                                                    </li>
                                                    <li class="nav-item">
                                                        <a class="nav-link justify-content-center btn btn-nav bg-gold" style="box-shadow: none; outline: revert;" href="{app_url}login">Inloggen</a>
                                                    </li>
                                                </ul>
                                            </Col>
                                        </Row>
                                    </Collapse>
                                {/if}
                            </div>

                            <div id="reg-login" class="d-none d-sm-inline-block float-end">
                                <ul class="navbar-nav mb-2 mb-sm-0 flex-sm-row">
                                    {#if $page.data.logged_in}
                                        <li class="nav-item">
                                            <ButtonDropdown>
                                                <DropdownToggle color="link" class="text-white" style="text-decoration: none;"><b>{$page.data.logged_in.first_name} {$page.data.logged_in.last_name}
                                                    </b> <img class="user-icon" src={user_icon} alt="Icoontje van een gebruiker" width="21.81" height="24.2">
                                                </DropdownToggle>
                                                <DropdownMenu>
                                                    <a class="wijzig-wachtwoord" href="/herstel-wachtwoord"><span>Wijzig wachtwoord</span></a>
                                                    <button type="button" class="dropdown-item logout no-hover-bg" on:click={logout}>Log uit</button>
                                                </DropdownMenu>
                                            </ButtonDropdown>
                                        </li>
                                    {:else}
                                        <li class="nav-item" style="margin-right: 58px;">
                                            <a class="nav-link justify-content-center text-white ms-4" href="{app_url}registreer">Registreren</a>
                                        </li>
                                        <li class="nav-item">
                                            <a class="nav-link justify-content-center btn btn-nav bg-gold" style="box-shadow: none; outline: revert;" href="{app_url}login">Inloggen</a>
                                        </li>
                                    {/if}
                                </ul>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    </nav>
</header>

<style lang="scss">
    #badge-div {
        position: relative;
        top: 13px;
    }

    #reg-login {
        margin-top: 9px;
    }

    .user-icon {
        height: 24.21px;
        color: white;
    }

    .wijzig-wachtwoord {
        text-decoration: none;
        padding: 4px 16px;

        &:hover {
            background-color: var(--bs-dropdown-link-hover-bg);
        }

        span {
            white-space: nowrap;
        }
    }

    .no-hover-bg {
        color: black;

        &:focus, &:focus-visible, &:active {
            background-color: white;
        }
    }

    .navbar {
        padding-top: 0;
        padding-bottom: 0;
    }

    .navbar-app {
        padding: 35px 40px 34px 51px;
        margin-right: 0;
        background: var(--dark-blue-color);
    }

    .nav-link {
        font-weight: 700;
        display: flex;

        &:hover {
            color: grey !important;
            text-decoration: none;
        }
    }

    .nav-item:last-child .nav-link:hover {
        color: white !important;
    }

    #navbar-toggler {
        padding-top: 12px;
        border: none;
    }

    .navbar-toggler-icon {
        background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzNiIgaGVpZ2h0PSIyMiIgdmlld0JveD0iMCAwIDM2IDIyIj48ZyBpZD0iR3JvdXBfMTM4IiBkYXRhLW5hbWU9Ikdyb3VwIDEzOCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTMxOCAtMzMpIj48bGluZSBpZD0iTGluZV82MCIgZGF0YS1uYW1lPSJMaW5lIDYwIiB4Mj0iMzYiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDMxOCAzNCkiIGZpbGw9Im5vbmUiIHN0cm9rZT0iI2ZmZiIgc3Ryb2tlLXdpZHRoPSIyIi8+PGxpbmUgaWQ9IkxpbmVfNjEiIGRhdGEtbmFtZT0iTGluZSA2MSIgeDI9IjM2IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzMTggNDQpIiBmaWxsPSJub25lIiBzdHJva2U9IiNmZmYiIHN0cm9rZS13aWR0aD0iMiIvPjxsaW5lIGlkPSJMaW5lXzYyIiBkYXRhLW5hbWU9IkxpbmUgNjIiIHgyPSIzNiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMzE4IDU0KSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjZmZmIiBzdHJva2Utd2lkdGg9IjIiLz48L2c+PC9zdmc+");
        font-size: 20px;
    }

    @media (max-width: 767px) {
        #badge-div {
            position: relative;
            top: 9px;
        }

        #reg-login {
            margin-top: 7px;
        }

        #nav-logo {
            width: 152px;
        }

        .navbar-app {
            padding: 21px 30px 20px 22px;
        }

        .navbar-nav {
            padding-top: 6px;
        }

        .nav-link {
            font-size: 12px;
        }
    }

    @media (max-width: 575px) {
        .navbar-app {
            padding: 21px 8px 20px 22px;
        }

        .navbar-nav {
            padding-top: 0;
        }

        .nav-link {
            font-size: 16px;
        }

        .nav-item:last-child .nav-link {
            padding-bottom: 8px !important;
        }
    }
</style>
